export default "__VITE_ASSET__4xednycr__"